<div class="modal">
    <div class="modal__header d-flex jc-flex-end">
        <button class="btn-close" type="button" (click)="closeModal()"><span class="btn-close__icon icon-close"></span></button>
    </div>
    <div class="modal__body">
        
        <form class="mt-half" [formGroup]="filterForm">

            <mat-form-field appearance="outline" class="width-100 mat-form-field--blue">
                <mat-label>Ciudad</mat-label>
                <mat-select formControlName="city">
                    <mat-option value="example">example</mat-option>
                </mat-select>
                <mat-error>Este campo es <strong>requerido</strong></mat-error>
            </mat-form-field>
            <mat-form-field appearance="outline" class="width-100 mat-form-field--blue">
                <mat-label>Baños</mat-label>
                <mat-select formControlName="bathroom">
                    <mat-option value="example">example</mat-option>
                </mat-select>
                <mat-error>Este campo es <strong>requerido</strong></mat-error>
            </mat-form-field>
            <mat-form-field appearance="outline" class="width-100 mat-form-field--blue">
                <mat-label>Barrio</mat-label>
                <mat-select formControlName="neighborhood">
                    <mat-option value="example">example</mat-option>
                </mat-select>
                <mat-error>Este campo es <strong>requerido</strong></mat-error>
            </mat-form-field>
            <mat-form-field appearance="outline" class="width-100 mat-form-field--blue">
                <mat-label>Antiguedad</mat-label>
                <mat-select formControlName="antiquity">
                    <mat-option value="example">example</mat-option>
                </mat-select>
                <mat-error>Este campo es <strong>requerido</strong></mat-error>
            </mat-form-field>
            <mat-form-field appearance="outline" class="width-100 mat-form-field--blue">
                <mat-label>Antiguedad</mat-label>
                <mat-select formControlName="antiquity">
                    <mat-option value="example">example</mat-option>
                </mat-select>
                <mat-error>Este campo es <strong>requerido</strong></mat-error>
            </mat-form-field>
            <mat-form-field appearance="outline" class="width-100 mat-form-field--blue">
                <mat-label>Tipo Transacción</mat-label>
                <mat-select formControlName="transactionType">
                    <mat-option value="example">example</mat-option>
                </mat-select>
                <mat-error>Este campo es <strong>requerido</strong></mat-error>
            </mat-form-field>
            <mat-form-field appearance="outline" class="width-100 mat-form-field--blue">
                <mat-label>Área</mat-label>
                <mat-select formControlName="area">
                    <mat-option value="example">example</mat-option>
                </mat-select>
                <mat-error>Este campo es <strong>requerido</strong></mat-error>
            </mat-form-field>
            <mat-form-field appearance="outline" class="width-100 mat-form-field--blue">
                <mat-label>Tipo de inmueble</mat-label>
                <mat-select formControlName="estateType">
                    <mat-option value="example">example</mat-option>
                </mat-select>
                <mat-error>Este campo es <strong>requerido</strong></mat-error>
            </mat-form-field>
            <mat-form-field appearance="outline" class="width-100 mat-form-field--blue">
                <mat-label>Estado</mat-label>
                <mat-select formControlName="status">
                    <mat-option value="example">example</mat-option>
                </mat-select>
                <mat-error>Este campo es <strong>requerido</strong></mat-error>
            </mat-form-field>
            <mat-form-field appearance="outline" class="width-100 mat-form-field--blue">
                <mat-label>Habitaciones</mat-label>
                <mat-select formControlName="bedrooms">
                    <mat-option value="example">example</mat-option>
                </mat-select>
                <mat-error>Este campo es <strong>requerido</strong></mat-error>
            </mat-form-field>
            <mat-form-field appearance="outline" class="width-100 mat-form-field--blue">
                <mat-label>Inmuebles/Proyectos</mat-label>
                <mat-select formControlName="estateProyects">
                    <mat-option value="example">example</mat-option>
                </mat-select>
                <mat-error>Este campo es <strong>requerido</strong></mat-error>
            </mat-form-field>

            <mat-form-field appearance="outline" class="width-100 mat-form-field--blue">
                <mat-label>Fecha desde</mat-label>
                <input matInput type="date" formControlName="minDate" placeholder="12 / 06 / 2020">
                <mat-error>Este campo es <strong>requerido</strong></mat-error>
            </mat-form-field>
            <mat-form-field appearance="outline" class="width-100 mat-form-field--blue">
                <mat-label>Fecha hasta</mat-label>
                <input matInput type="date" formControlName="maxDate" placeholder="12 / 06 / 2020">
                <mat-error>Este campo es <strong>requerido</strong></mat-error>
            </mat-form-field>

            <mat-form-field appearance="outline" class="width-100 mt-half mat-form-field--blue">
                <mat-label>codigo de inmueble</mat-label>
                <input matInput type="text" formControlName="code" placeholder="124312">
                <mat-error>Este campo es <strong>requerido</strong></mat-error>
            </mat-form-field>
        </form>
        
        <div class="d-flex jc-space-evenly my-half">
            <button class="cancel-btn text-secondary-base px-large text-xsmall" type="button" mat-dialog-close>CANCELAR</button>
            <button class="button rounded secondary px-large text-xsmall" type="button">BUSCAR</button>
        </div>
    </div>
    
</div>  